'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _noop = require('../../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _slider = require('react-slick/lib/slider');

var _slider2 = _interopRequireDefault(_slider);

var _Carousel = require('./Carousel.scss');

var _Carousel2 = _interopRequireDefault(_Carousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_NUMBER_OF_ITEMS_TO_SHOW = 4;

var Carousel = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Carousel, _Component);

    function Carousel() {
        (0, _classCallCheck3.default)(this, Carousel);
        return (0, _possibleConstructorReturn3.default)(this, (Carousel.__proto__ || (0, _getPrototypeOf2.default)(Carousel)).apply(this, arguments));
    }

    (0, _createClass3.default)(Carousel, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'className', 'index']);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.index !== this.props.index) {
                this.slider.slickGoTo(this.props.index);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                afterChange = _props.afterChange,
                children = _props.children,
                className = _props.className,
                index = _props.index;

            // don't draw the carousel if we've got nothing to draw

            if (!children) {
                return null;
            }

            var settings = {
                afterChange: afterChange,
                dots: false,
                infinite: true,
                initialSlide: index,
                lazyLoad: true, // DONT CHANGE THIS - SHOULD BE `TRUE`.
                ref: function ref(slider) {
                    _this2.slider = slider;
                },
                responsive: [{ breakpoint: 992, settings: { slidesToScroll: 3, slidesToShow: 3 } }, { breakpoint: 768, settings: { slidesToScroll: 2, slidesToShow: 2 } }, { breakpoint: 320, settings: { slidesToScroll: 1, slidesToShow: 1 } }],
                slidesToScroll: DEFAULT_NUMBER_OF_ITEMS_TO_SHOW,
                slidesToShow: DEFAULT_NUMBER_OF_ITEMS_TO_SHOW
            };

            var classes = (0, _classnames2.default)(_Carousel2.default.carousel, className);

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, _react2.default.createElement(
                _slider2.default,
                settings,
                children
            ));
        }
    }]);
    return Carousel;
}(_react.Component), _class.defaultProps = {
    afterChange: _noop2.default
}, _temp);
exports.default = Carousel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/Carousel.js
// module id = Q90x
// module chunks = 46